import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  background: ${({ theme }) => theme.colors.black};
  color: white;
  padding: ${({ theme }) => `${theme.spacing.xl} 0 ${theme.spacing.lg}`};
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    color: white;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }
  
  p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  
  li {
    margin-bottom: 0.5rem;
    
    a {
      color: ${({ theme }) => theme.colors.lightGray};
      text-decoration: none;
      transition: ${({ theme }) => theme.transitions.default};
      font-weight: 500;
      
      &:hover {
        color: ${({ theme }) => theme.colors.accent};
        transform: translateX(5px);
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: ${({ theme }) => theme.transitions.default};
  
  &:hover {
    background: ${({ theme }) => theme.colors.accent};
    transform: translateY(-2px);
  }
`;

const ContactInfo = styled.div`
  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
    color: rgba(255, 255, 255, 0.8);
    
    .icon {
      font-size: 1.125rem;
    }
  }
`;

const Newsletter = styled.div`
  .newsletter-form {
    display: flex;
    gap: 0.5rem;
    margin-top: 1rem;
    
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      flex-direction: column;
    }
  }
  
  input {
    flex: 1;
    padding: 1rem 1.25rem;
    border: 2px solid ${({ theme }) => theme.colors.gray};
    border-radius: 0;
    background: white;
    transition: ${({ theme }) => theme.transitions.default};
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.6);
    }
    
    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.accent};
      box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.1);
    }
  }
  
  button {
    background: ${({ theme }) => theme.colors.primary};
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    cursor: pointer;
    transition: ${({ theme }) => theme.transitions.default};
    
    &:hover {
      background: ${({ theme }) => theme.colors.primaryDark};
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`;

const FooterNav = styled.div`
  display: flex;
  gap: 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    gap: 1rem;
  }
  
  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 0.875rem;
    
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <h3>Adara Dance Studio</h3>
            <p>
              Tworzymy magiczne chwile poprzez taniec, pomagając uczniom odkrywać 
              swoją pasję i wyrazić siebie przez ruch. Jesteśmy Twoim partnerem w tanecznej podroży.
            </p>
            <SocialLinks>
              <SocialLink href="#" aria-label="Facebook">📘</SocialLink>
              <SocialLink href="#" aria-label="Instagram">📷</SocialLink>
              <SocialLink href="#" aria-label="LinkedIn">💼</SocialLink>
              <SocialLink href="#" aria-label="Twitter">🐦</SocialLink>
              <SocialLink href="#" aria-label="GitHub">🐙</SocialLink>
            </SocialLinks>
          </FooterSection>
          
          <FooterSection>
            <h3>Zajęcia</h3>
            <FooterLinks>
              <li><button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Balet klasyczny</button></li>
              <li><button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Hip-Hop</button></li>
              <li><button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Taniec współczesny</button></li>
              <li><button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Taniec latino</button></li>
              <li><button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Taniec towarzyski</button></li>
              <li><button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Zajęcia dla dzieci</button></li>
            </FooterLinks>
          </FooterSection>
          
          <FooterSection>
            <h3>Kontakt</h3>
            <ContactInfo>
              <div className="contact-item">
                <span className="icon">📍</span>
                <span>ul. Przykładowa 123, 65-001 Zielona Góra</span>
              </div>
              <div className="contact-item">
                <span className="icon">📞</span>
                <span>+48 123 456 789</span>
              </div>
              <div className="contact-item">
                <span className="icon">✉️</span>
                <span>kontakt@adaradance.pl</span>
              </div>
              <div className="contact-item">
                <span className="icon">🕒</span>
                <span>Pon - Pt: 9:00 - 18:00</span>
              </div>
            </ContactInfo>
          </FooterSection>
          
          <FooterSection>
            <h3>Newsletter</h3>
            <p>
              Zapisz się do naszego newslettera i bądź na bieżąco z najnowszymi 
              wydarzeniami, warsztatami i występami w naszym studiu.
            </p>
            <Newsletter>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Twój adres email" 
                />
                <button type="submit">Zapisz się</button>
              </div>
            </Newsletter>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <Copyright>
            © {currentYear} Adara Dance Studio. Wszystkie prawa zastrzeżone.
          </Copyright>
          <FooterNav>
            <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Polityka prywatności</button>
            <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Regulamin</button>
            <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}>Cookies</button>
          </FooterNav>
        </FooterBottom>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
